import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
const stack = [{
  item: 'Yoga Teacher System™',
  primary: true
}, {
  item: '120 Complete Ready-to-Teach Classes',
  primary: true
}, {
  item: '6 Professional Volumes'
}, {
  item: '20 Classes Per Volume'
}, {
  item: '40+ Weeks of Teaching Material*'
}, {
  item: 'Complete Class Structures'
}, {
  item: '5 Premium Bonus Resources'
}, {
  item: 'Instant Digital Access'
}];
export function OfferSection() {
  return <section id="offer" className="w-full bg-ivory py-10 sm:py-14 lg:py-20" aria-labelledby="offer-heading" data-id="element-128" data-mp="mgwk5ag6pwfl">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-129" data-mp="wdj4ly4lmlh3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-130" data-mp="waww9w9vw1xt">
          <div className="flex justify-center" data-id="element-131" data-mp="2t6b7ci7r7zm2">
            <SectionLabel data-id="element-132" data-mp="2t7m96chn2xaj">The complete offer</SectionLabel>
          </div>
          <h2 id="offer-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-133" data-mp="2y4w58azja77c">
            Everything you get today
          </h2>
        </div>

        <div className="mt-6 overflow-hidden rounded-3xl border border-sandDark bg-cream shadow-card" data-id="element-134" data-mp="sxp1mkbdfwp8">
          <ul className="grid gap-px bg-sandDark/60 sm:grid-cols-2" data-id="element-135" data-mp="owdjt0yqofrl">
            {stack.map(({
            item,
            primary
          }) => <li key={item} className="flex items-center justify-center gap-2.5 bg-cream px-4 py-3 text-center sm:px-6" data-id="element-136" data-mp="1lmmj4l7rdpgx">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-137" data-mp="1clod5xdrf7vp">
                  <CheckIcon className="h-2.5 w-2.5 text-ivory" aria-hidden="true" data-id="element-138" data-mp="17mv90vkd4t87" />
                </span>
                <span className={`text-[0.85rem] leading-snug sm:text-[0.95rem] ${primary ? 'font-semibold text-ink' : 'text-muted'}`} data-id="element-139" data-mp="172er7acvz7n">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="border-t border-sandDark bg-ivory px-4 py-6 text-center sm:px-8 sm:py-8" data-id="element-140" data-mp="2o83jdzwxa3i">
            <div className="rounded-[1.75rem] border border-gold/50 bg-cream p-1.5" data-id="element-141" data-mp="3ktunu7o59we9">
              <div className="rounded-[1.4rem] border border-gold/25 bg-ivory px-4 py-7 sm:px-8" data-id="element-142" data-mp="3oumv4vdghr7w">
                <span className="inline-block rounded-full bg-forest px-4 py-1.5 text-[0.55rem] font-semibold uppercase tracking-label text-ivory" data-id="element-143" data-mp="3b3rta31dkadt">
                  Today
                </span>
                <p className="mt-3 font-serif text-[4.5rem] font-semibold leading-none text-forest sm:text-8xl" data-id="element-144" data-mp="315lsjorb1aaj">
                  $27
                </p>
                <p className="mt-2 flex items-center justify-center gap-2 text-[0.62rem] font-semibold uppercase tracking-label text-muted" data-id="element-145" data-mp="364yi4h9k8vgt">
                  <span className="h-px w-5 bg-gold/50" aria-hidden="true" data-id="element-146" data-mp="2x3h2f002evsn" />
                  USD · One-time payment
                  <span className="h-px w-5 bg-gold/50" aria-hidden="true" data-id="element-147" data-mp="2dh5ertog5hyo" />
                </p>
                <p className="mt-1 text-[0.62rem] font-semibold uppercase tracking-label text-clay" data-id="element-148" data-mp="28jdm2xfz9rtf">
                  No subscription
                </p>
              </div>
            </div>

            <div className="mt-6" data-id="element-149" data-mp="2igicxakrqbgk">
              <CtaButton href="https://yogateachersystem.impultienda.ar/checkout" label="Get Yoga Teacher System™ now" microcopy="Instant Digital Access • One-Time Purchase" data-id="element-150" data-mp="2ig8nbo3my6be" />
            </div>

            <p className="mt-5 text-[0.58rem] leading-relaxed text-muted" data-id="element-151" data-mp="366cn1kdpdlx4">
              *Based on teaching approximately 3 classes per week.
            </p>
          </div>
        </div>
      </div>
    </section>;
}